<template>
  <v-select
    :value="selectedOption"
    :options="options"
    :filterable="false"
    label="full_name"
    :placeholder="placeholder"
    :clearable="clearable"
    :loading="loading"
    :disabled="disabled"
    @open="onOpen"
    @search="onSearch"
    @input="onInput"
  >
    <template #option="{ full_name, phone }">
      <span>{{ full_name }}</span>
      <small v-if="phone" class="text-muted ml-2">{{ phone }}</small>
    </template>
    <template #selected-option="{ full_name, phone }">
      <span>{{ full_name }}</span>
      <small v-if="phone" class="text-muted ml-2">{{ phone }}</small>
    </template>
    <template #no-options="{ search, searching }">
      <span v-if="loading" class="text-muted">Loading…</span>
      <span v-else-if="searching" class="text-muted">No customers found for "{{ search }}".</span>
      <span v-else class="text-muted">Type to search customers…</span>
    </template>
    <template #list-footer v-if="hasMore">
      <li class="text-center text-muted py-1" style="font-size:12px;">
        Type to narrow results
      </li>
    </template>
  </v-select>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'CustomerSearchSelect',

  components: { vSelect },

  props: {
    value:       { default: null },
    placeholder: { type: String,  default: 'Search customer…' },
    clearable:   { type: Boolean, default: true },
    disabled:    { type: Boolean, default: false },
  },

  data() {
    return {
      options:        [],
      loading:        false,
      searchTimer:    null,
      selectedOption: null,
      hasMore:        false,
      defaultLoaded:  false,
    }
  },

  watch: {
    value(id) {
      if (!id) this.selectedOption = null
    },
  },

  methods: {
    // Load page 1 immediately when dropdown opens so the user sees something right away
    async onOpen() {
      if (this.defaultLoaded) return
      this.loading = true
      try {
        const { data } = await axios.get('/api/allcustomers', {
          params: { perPage: 20 },
        })
        const list  = data.data || data
        this.options = list
        // Show hint if there are more customers than the page
        this.hasMore = (data.total ?? list.length) > list.length
        this.defaultLoaded = true
      } catch {
        // silently fail — user can still type to search
      } finally {
        this.loading = false
      }
    },

    onSearch(search, loading) {
      clearTimeout(this.searchTimer)

      // User cleared the search — restore default list
      if (!search || search.length < 1) {
        if (this.defaultLoaded) {
          // Already have the default list; nothing to do
        }
        loading(false)
        return
      }

      loading(true)
      this.loading = true
      this.searchTimer = setTimeout(async () => {
        try {
          const { data } = await axios.get('/api/allcustomers', {
            params: { search, perPage: 20 },
          })
          const list  = data.data || data
          this.options = list
          this.hasMore = (data.total ?? list.length) > list.length
        } catch {
          // keep whatever options are showing
        } finally {
          loading(false)
          this.loading = false
        }
      }, 350)
    },

    onInput(customer) {
      this.selectedOption = customer
      this.$emit('input', customer ? customer.id : null)
      this.$emit('customer-selected', customer || null)
    },
  },
}
</script>
